<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    :custom-sort="customSort"
    class="header"
    hide-actions
  >
    <template v-slot:items="props">
      <slot name="firstCol" :text="props.item" />
      <td
        v-for="(item, index) in hasFirstColumnSlot ? headers.slice(1) : headers"
        :key="
          props.item[item.value] ? `${index}${props.item[item.value]}` : index
        "
        :class="props.item[item.value] !== undefined &&
          props.item[item.value] !== null &&
          props.item[item.value] !== 'No Data' ? 'number--text text-xs-center' : 'error--text text-xs-center'"
      >
        {{
          props.item[item.value] !== undefined &&
          props.item[item.value] !== null &&
          props.item[item.value] !== "No Data"
            ? props.item[item.value]
            : $t("No Data")
        }}
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: function () {
        return [];
      },
    },
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
    search: {
      type: String,
      default: "",
    },
    customSort: {
      type: Function,
    },
    isPaginationFalse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasFirstColumnSlot() {
      return !!this.$scopedSlots["firstCol"];
    },
  },
};
</script>

<style scoped>
.header {
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #38405c;
}
</style>

<style>
.header .v-table__overflow {
  overflow: unset;
}

table.v-table thead tr {
  height: 38px;
}
</style>
